
import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'

import { useAuth } from '../../../Hooks/UseAuth'
import useTranslation from '@/Hooks/UseTranslation'
import { useFeedback } from '@/Hooks/UseFeedback'

import UserAvatar from '../../../Components/UserAvatar/UserAvatar'
import ToggleNotifications from './ToggleNotifications'
import HeaderChatAction from './HeaderChatAction'
import HeaderSearch from './HeaderSearch'
import PlansSummaryModal from './PlansSummaryModal'
import ProjectSwitcher from './ProjectSwitcher'

import './Header.scss'

interface Props {
  menu: any
  selectedProject?: any
}

const Header = ({ selectedProject }: Props) => {

  const { t } = useTranslation()

  const history = useHistory()

  const { show: showFeedbackForm } = useFeedback()

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  const [showPlansModal, setShowPlansModal] = useState(false)

  const { userData , logout } = useAuth()

  const location = useLocation().pathname;

  const handleLogout = async () => {

    const { isConfirmed } = await Swal.fire({
      title: t('USER_MENU:Logout'),
      text: t('USER_MENU:LogoutConfirm'),
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: t('USER_MENU:LogoutConfirmButton'),
      cancelButtonText: t('USER_MENU:LogoutCancelButton')
    })

    if (!isConfirmed) return

    logout()
  }

  const handleProfileClick = () => {
    setIsUserMenuOpen(false)
    history.push('/profile')
  }

  const handlePlansClick = () => {
    setIsUserMenuOpen(false)
    setShowPlansModal(true)
  }

  const handleFeedbackClick = () => {
    setIsUserMenuOpen(false)
    showFeedbackForm()
  }

  const handleMenuLogout = () => {
    setIsUserMenuOpen(false)
    handleLogout()
  }

  return (
    <>
      <div className='main-header pl4-shell-header'>
        <div className="logo logo-left pl4-shell-brand">
          <img className="pl4-brand-icon" src="/svg-icons/logo-icon.svg" alt="" aria-hidden="true" />
          <img className="pl4-brand-logo" src="/svg-icons/logo.svg" alt="PL4NNER" />
        </div>
        <div className="pl4-shell-divider" aria-hidden="true" />
        <ProjectSwitcher selectedProject={selectedProject} />
        <HeaderSearch />
        <div className='logo logo-right pl4-shell-actions'>
          <div className="pl4-shell-action-icons">
            <ToggleNotifications />
            <HeaderChatAction />
          </div>
          <div
            className={`btn-user-dialog cursor-pointer ${isUserMenuOpen ? 'is-open' : ''}`}
            onClick={() => setIsUserMenuOpen((isOpen) => !isOpen)}
            aria-expanded={isUserMenuOpen}
          >
            {location == '/profile' && (
              <span className="username">
                {userData?.name} {userData?.surname}
              </span>
            )}
            {userData?.name && userData?.surname ? (
              <UserAvatar user={userData} />
            ) : (
              <span
                className={`${location == '/profile' || isUserMenuOpen ? 'icon-usuario_full' : 'icon-usuario'}`}
              />
            )}
            <div className="user-menu-name">
              <span>{t('HEADER:Hi')},</span>
              <strong>{userData?.name}</strong>
            </div>
            <span className="pl4-user-chevron" aria-hidden="true" />
            {isUserMenuOpen && (
              <div
                className="pl4-user-dropdown"
                onClick={(event) => event.stopPropagation()}
              >
                <div className="pl4-user-dropdown__identity">
                  <UserAvatar user={userData} />
                  <div>
                    <strong>{userData?.name} {userData?.surname}</strong>
                    <span>{userData?.email}</span>
                  </div>
                </div>
                <div className="pl4-user-dropdown__divider" />
                <button type="button" onClick={handleProfileClick}>
                  <i className="far fa-user-circle" aria-hidden="true" />
                  <span>{t('USER_MENU:MyProfile')}</span>
                </button>
                <button type="button" onClick={handlePlansClick}>
                  <i className="far fa-gem" aria-hidden="true" />
                  <span>Planes</span>
                  <em>PRO</em>
                </button>
                <button type="button" onClick={handleFeedbackClick}>
                  <span className="icon-mensajes" />
                  <span>{t('USER_MENU:GiveFeedback')}</span>
                </button>
                <div className="pl4-user-dropdown__divider" />
                <button type="button" className="is-danger" onClick={handleMenuLogout}>
                  <span className="icon-cancelar" />
                  <span>{t('USER_MENU:Logout')}</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <PlansSummaryModal
        show={showPlansModal}
        onHide={() => setShowPlansModal(false)}
      />
    </>
  )
}

export default Header
